import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.6162 3.26835L11.9994 0.186157L8.38263 3.26835L3.64575 3.64636L3.26774 8.38324L0.185547 12L3.26774 15.6168L3.64575 20.3537L8.38264 20.7317L11.9994 23.8139L15.6162 20.7317L20.3531 20.3537L20.7311 15.6168L23.8133 12L20.7311 8.38325L20.3531 3.64636L15.6162 3.26835ZM10.9994 16.4142L6.58521 12L7.99942 10.5858L10.9994 13.5858L16.4994 8.08582L17.9136 9.50003L10.9994 16.4142Z"}}]};

const VerifiedFilled = Vue.extend<IconProps>({
  name: 'VerifiedFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'verified-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default VerifiedFilled;
